import { FeatureFlag } from '@bymason/controller-api-hooks';
import { callGqlEndpoint, useGqlDataHook } from '@bymason/utils';
import { useCallback } from 'react';

export function useGetFeatureFlags(clientToken: string) {
  const handleGetData = useCallback(() => {
    return callGqlEndpoint<{ featureFlags: FeatureFlag[] }>({
      clientToken,
      query: `
        {
          featureFlags {
            name
            description
          }
        }
      `,
    });
  }, [clientToken]);

  return useGqlDataHook(handleGetData);
}
